<template lang="pug">
v-form(ref='form', v-model='valid', lazy-validation='' )
  v-text-field.rounded-lg(v-model='motionDraft.title', dense rounded  :rules='nameRules', :label="$t('create.forms.title')", filled)
  v-textarea.rounded-lg(v-model='motionDraft.description', dense  rounded auto-grow rows="2" row-height="20" :label="$t('create.forms.description')",  filled)
  v-select.rounded-lg(v-model="motionDraft.categoryIDs" :items="allCategories" item-text="title" item-value="id" dense rounded hide-details  deletable-chips multiple filled roundedchips :label="$t('clips.categories')")
</template>

<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import { nameRules, descriptionRules } from "@/utils/validations";

export default {
  name: "MotionForm",
  data() {
    return {
      valid: false,
      nameRules,
      descriptionRules,
    };
  },
  computed: {
    ...mapFields("create", {
      motionDraft: "motionDraft",
    }),
    ...mapState({
      categories: (state) => state.settings.categories,
      allCategories: (state) => state.settings.categories,
    }),
  },
};
</script>
